import { h, RefObject } from "preact";
import { useMemo } from "preact/hooks";

import Reaction from "../../../../../foundation/model/Reaction";
import Popover, { PopoverMode, PopoverPosition } from "../../../Popover";
import ReactionButton from "../../ReactionButton";
import ReactionListLocation from "../../ReactionListLocation";

import styles from "./RemainingReactionsPopover.module.css";

interface Props {
    targetButton: RefObject<HTMLButtonElement>;
    reactions: Reaction[];
    userId: string;
    location: ReactionListLocation;
    readOnly?: boolean;
    disabled?: boolean;
    open: boolean;
    onSelect(emoji: string): void;
    onClose(): void;
}

export default function RemainingReactionsPopover({
    targetButton,
    reactions,
    userId,
    location,
    readOnly = false,
    disabled = false,
    open,
    onSelect,
    onClose
}: Props) {
    const reactionsKey = useMemo(() =>
        reactions.map(rctn => `${rctn._id}-${rctn.users.map(user => user._id).sort().join("-")}`).join("-")
    , [reactions]);

    function renderContent() {
        return (
            <div class={styles.reactions}>
                {reactions.map(({ _id, type, users }) => (
                    <ReactionButton
                        key={_id}
                        emoji={type}
                        users={users}
                        userId={userId}
                        location={location}
                        readOnly={readOnly}
                        disabled={disabled}
                        onClick={onSelect}/>
                ))}
            </div>
        );
    }

    return (
        <Popover
            key={reactionsKey}
            class={styles.remainingReactionsPopover}
            mode={PopoverMode.Portal}
            position={PopoverPosition.Bottom}
            offset={6}
            portalOptions={{
                targetRef: targetButton
            }}
            content={renderContent()}
            open={open}
            hasOverlay
            onClose={onClose}/>
    );
}
